import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const theme = localStorage.getItem('theme') || 'light';
let mode = false
if (theme === 'dark') {
  document.documentElement.setAttribute('theme', 'dark');
  mode = true;
}

export default new Vuex.Store({
  state: {
    isDarkMode: mode,
    framesData: [],
    isMobileSize: false,
  },
  mutations: {
    setDark(state, payload) {
      state.isDarkMode = payload;
    },
    setFramesData(state, data) {
      state.framesData = data;
    },
    setMobileSize(state, payload) {
      state.isMobileSize = payload;
    },
  },
  actions: {},
  getters: {
    isDarkMode(state) {
      return state.isDarkMode;
    },
    framesData(state) {
      return state.framesData;
    },
    isMobileSize(state) {
      return state.isMobileSize;
    },
  },
  modules: {},
});
